import { Button, Text, HStack, VStack } from "@chakra-ui/react";
import { formatPlate } from "../../utils/formatPlate";
import { getTipoCarga } from "../../utils/getTipoCarga";
import { faTruck, faUser, faWeight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ShippingItem: React.FC<{
  carga: Record<string, any>;
  onClick: () => void;
}> = ({ carga, onClick }) => {
  const plateFormated = carga.ff08_001_c
    ? formatPlate(carga.ff08_001_c.trim())
    : "SEM PLACA";
  const jaCarregando = carga.iniciou_carregamento * 1 === 1;
  const qtdFaltando = carga.qtd_a_ler * 1 + carga.qtd_bonificacao_ler * 1 - carga.qtd_lida * 1;
  const cor = !jaCarregando ? "blue" : qtdFaltando > 0 ? "red" : "green";

  return (
    <Button
      py="0.6rem"
      px="0.3rem"
      border="1px"
      variant="solid"
      colorScheme={cor}
      display="flex"
      flexDirection="column"
      textAlign="left"
      alignItems="start"
      h="auto"
      onClick={onClick}
      my="0.1rem"
      w="100%"
    >
      <Text fontSize="lg" fontWeight="bold" mb={2}>
        {plateFormated} - Agrupamento {carga.numero}
      </Text>

      <VStack spacing={2} align="stretch" w="100%">
        <HStack>
          <FontAwesomeIcon icon={faTruck} />
          <Text>Tipo carga: {getTipoCarga(carga)}</Text>
        </HStack>

        <HStack>
          <FontAwesomeIcon icon={faUser} />
          <Text noOfLines={1}>Motorista: {carga.a03_003_c || "Não identificado"}</Text>
        </HStack>

        <HStack>
          <FontAwesomeIcon icon={faWeight} />
          <Text>Peso Tara: {carga.peso_balanca_entrada * 1}</Text>
        </HStack>
      </VStack>
    </Button>
  );
};